export default __webpack_public_path__ + "media/images/appearance-preview-67984d941280ad4a3ce72f9349192bca.png";